import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { ul } from './helpers';
import { COMPANY_OVERVIEW_NAMES } from '../Sections/Overview/CompanyOverview/utils/form';
import { FUNDING_NEEDS_NAMES } from '../Sections/Overview/FundingNeedsOverview/utils/form';
import { COMPANY_PROJECT_NAMES } from '../Sections/Overview/ProjectOverview/utils/form';

const OVERVIEW_COMPANY_INSTRUCTIONS = {
  [COMPANY_OVERVIEW_NAMES.LIFE_CYCLE_STAGES]: {
    name: 'Life Cycle Stage',
    instruction:
      "Indicate the current life cycle stage of your company succinctly, highlighting whether it's in the startup, growth, maturity, or decline phase.",
  },
};

const OVERVIEW_PROJECT_INSTRUCTIONS = {
  [COMPANY_PROJECT_NAMES.STATUS]: {
    name: 'Project Status',
    instruction: `Select the appropriate stage:
      ${ul([
        'Idea Assessment: Determining the feasibility and potential of the business idea.',
        'Research and Development: Creating prototypes, testing, and conducting detailed market or technical research.',
        'Evaluation and Selection: Assessing various strategies or models and selecting the most suitable one.',
        'Financing: Securing the necessary financial resources to fund the project.',
        'Implementation: Executing the business plan and launching the product or service.',
        'Operation and Management: Managing the ongoing daily operations and ensuring the business functions effectively.',
      ])}`,
    exampleOne: 'Evaluation and Selection',
    exampleTwo: 'Implementation',
  },
};

const FUNDING_NEEDS_INSTRUCTIONS = {
  [FUNDING_NEEDS_NAMES.FUNDING_DIRECTIONS]: {
    name: 'Funding Directions',
    instruction:
      'Specify budget allocations for each purpose: R&D, Marketing, Working Capital, Construction, Equipment.',
    exampleOne: '',
    exampleTwo: '',
  },
};

export const OVERVIEW_INSTRUCTIONS = {
  [BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.COMPANY]: OVERVIEW_COMPANY_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.PROJECT]: OVERVIEW_PROJECT_INSTRUCTIONS,
  [BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.FUNDING_NEEDS]: FUNDING_NEEDS_INSTRUCTIONS,
};
